import React, { useEffect, useState, useContext } from 'react';
import { Input, FormGroup, Label } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../stateManagment/reduxStore';
import rootAction from '../../../stateManagment/actions/rootAction';
import { useGetContentAssetQuery } from '../../../services/content';
import VASTemplateV2 from '../../components/products/VASTemplateV2';
import { formatCurrency } from '../../../helpers/ConversionHelper';
import { ToggleContext } from "../../../ToggleProvider.js";

const EmbroiderySelector = ({ embroideryPresets, embPreviewBaseUrl, multiple = false, isInvalid = false, hexCode, resetEmbError, isEmbDropdown }) => {
    const dispatch = useAppDispatch();
    const { data: customEmbroideryContent, isFetching: isCustomEmbroideryContentLoading } = useGetContentAssetQuery('custom-embroidery-content');
    const [selectType, setSelectType] = useState(1);
    const [selectedOption, setSelectedOption] = useState(-1);
    const selectedEmbroideryPresets = useSelector((state) => state.pdpReducer.selectedEmbroideryPresets);
    const siteInfo = useSelector(state => state.commonReducer);
    const { isToggled, } = useContext(ToggleContext);
    const safeText = (value) => String(value ?? '');

    const handleItemToggle = (itemId) => {
        resetEmbError();
        setSelectedOption(itemId);
        dispatch(rootAction.pdpActions.setRemoveEmbroideryTextValidation());
        if (multiple) {
            if (selectedEmbroideryPresets.includes(itemId)) {
                dispatch(rootAction.pdpActions.setActiveEmbroideryPresets(selectedEmbroideryPresets.filter((item) => item !== itemId)));
            } else {
                dispatch(rootAction.pdpActions.setActiveEmbroideryPresets([...selectedEmbroideryPresets, itemId]));
            }
        } else {
            dispatch(rootAction.pdpActions.setActiveEmbroideryPresets([itemId]));
        }
    };

    useEffect(() => {
        setSelectedOption(selectedEmbroideryPresets[0]);
    }, []);

    useEffect(() => {
        dispatch(rootAction.pdpActions.setRemoveEmbroideryTextValidation());
        dispatch(rootAction.pdpActions.setCurrentEmbroideryConfig({ currentVas: embroideryPresets.TemplateDescriptor?.Templates[selectedOption]?.VASData, changedVas: [] }));
        dispatch(rootAction.pdpActions.setShowEmbroideryError(false))
    }, [selectedOption]);

    let optionalSelect = null;
    if (embroideryPresets.TemplateDescriptor?.Optional) {
        optionalSelect = (
            <FormGroup check>
                <Input
                    type="radio"
                    id={`embroidery-preset-optional`}
                    checked={(multiple && selectedEmbroideryPresets.includes(-1)) || (!multiple && selectedEmbroideryPresets[0] === -1)}
                    onChange={() => handleItemToggle(-1)}
                />
                <Label for={`embroidery-preset-optional`} check>No Embroidery</Label>
            </FormGroup>
        );
    }

    const renderDropdownItems = () => {
        return (
            <FormGroup>
                <Input
                    type="select"
                    id={`embroidery-select`}
                    className={isInvalid ? 'is-invalid': ''}
                    onChange={(e) => {
                        e.target.title = e.target.options[e.target.selectedIndex].text;
                        handleItemToggle(e.target.value)
                    }}
                    value={selectedEmbroideryPresets[0]}
                >
                    {!!siteInfo?.embChoiceDropdownDefaultOptionText &&
                        <option value={-2}>{siteInfo.embChoiceDropdownDefaultOptionText}</option>}
                    {embroideryPresets.TemplateDescriptor?.Optional &&
                        <option value={-1}>No Embroidery</option>}
                    {embroideryPresets.TemplateDescriptor?.Templates.map(({ Price: price, TemplateName: name, TemplateNameAllotment: allotmentName, index: i }) => (
                        isToggled ? 
                            <option key={i} value={i}>{safeText(allotmentName ?? name)}</option>
                            :
                            <option key={i} value={i}>{safeText(name).replace("$[[price]]", formatCurrency(price))}</option>
                        
                    ))}
                </Input>
            </FormGroup>
        );
    };

    const renderRadioItems = () => {
        return embroideryPresets.TemplateDescriptor?.Templates.map(({ Price: price, TemplateName: name, TemplateNameAllotment: allotmentName, VASData: vasData, index: i }) => (
            <React.Fragment key={i}>
                <FormGroup check>
                    <Input
                        type="radio"
                        id={`embroidery-preset-${i}`}
                        checked={(multiple && selectedEmbroideryPresets.includes(i)) || (!multiple && selectedEmbroideryPresets[0] === i)}
                        onChange={() => handleItemToggle(i)}
                    />
                    {isToggled ? 
                        <Label for={`embroidery-preset-${i}`} check>{safeText(allotmentName)}</Label>
                    :
                        <Label for={`embroidery-preset-${i}`} check>{safeText(name).replace("[[price]]", safeText(price))}</Label>
                    }
                </FormGroup>
                {((multiple && selectedEmbroideryPresets.includes(i)) || (!multiple && selectedEmbroideryPresets[0] === i)) &&
                    <VASTemplateV2
                        key={hexCode}
                        vasData={vasData}
                        VasSelectionIndex={i}
                        ItemChecked={i === 0 && (!embroideryPresets.TemplateDescriptor?.Optional)}
                        PreviewBaseUrl={embPreviewBaseUrl}
                        hexCode={hexCode}
                        readOnly={false}
                    />
                }
            </React.Fragment>
        ));
    };

    return (
        <div>
            <div className='align-items-center d-flex font-weight-bold mb-2 w-100'>
                <span className="icon icon-embroideryNeedle mr-3"></span>
                Embroidery
            </div>
            {embroideryPresets.TemplateDescriptor?.Templates?.length > 1 && <div className="custom-embroidery-content my-2" dangerouslySetInnerHTML={{ __html: customEmbroideryContent?.ContentValue }} /> }

            {!isEmbDropdown ?
                <>
                    {optionalSelect}
                    {renderRadioItems()}
                </>
                :
                <>
                    {embroideryPresets.TemplateDescriptor?.Templates?.length > 0 && renderDropdownItems()}
                    {selectedOption > -1 &&
                        <VASTemplateV2
                            key={selectedOption}
                            vasData={embroideryPresets.TemplateDescriptor?.Templates[selectedOption].VASData}
                            VasSelectionIndex={selectedOption}
                            ItemChecked={selectedOption === 0 && (!embroideryPresets.TemplateDescriptor?.Optional)}
                            PreviewBaseUrl={embPreviewBaseUrl}
                            hexCode={hexCode}
                            readOnly={false}
                        />
                    }
                </>
            }
        </div>
    );
};

export default EmbroiderySelector;
